import { getConfig } from 'functions/getConfig';

// Saved for future implementation
// export const FRONT_LINKS = [
//   { en: "About Future Skill", sv: "Om Future Skill", to: "/about" },
//   {
//     en: "Coding tests and challenges",
//     sv: "Kodtester och kodtävlingar",
//     to: "/recruitment"
//   },
//   { en: "Careers", sv: "Karriär", to: "/careers" },
//   { en: "Contact us", sv: "Kontakta oss", to: "/contact" }
// ];

export const FRONT_LINKS = [
  { de: 'Courses', en: 'Courses', sv: 'Courses', to: '/courses' },
  { de: 'Übungen', en: 'Exercises', sv: 'Övningar', to: '/exercises' },
  // { de: 'Freecode', en: 'Freecode', sv: 'Freecode', to: '/freecode' },
  { de: 'Challenges', en: 'Challenges', sv: 'Utmaningar', to: '/challenges' },
];

export const LOGGED_IN_LINKS = () => [
  {
    de: 'Tests',
    en: 'Tests',
    sv: 'Tester',
    extTo: `${getConfig().REDIRECTION_URL}/tests`,
  },
];

export const ADMIN_LINKS = () => [
  {
    de: 'Dashboard',
    en: 'Dashboard',
    sv: 'Dashboard',
    extTo: `${getConfig().REDIRECTION_URL}/dashboard`,
  },
];

// export const FRONT_BUTTONS = [
//   {
//     en: "Challenges",
//     to: "/challenges",
//     style: "secondary"
//   },
//   {
//     en: "For companies",
//     to: getConfig().REDIRECTION_URL,
//     style: "primary",
//     externalLink: true
//   }
// ];

export const BASE_BUTTONS = [
  { de: 'Für Unternehmen', en: 'For companies', sv: 'För företag', to: '/company', style: 'primary' },
];

export const FOR_DEV_BUTTONS = [
  { de: 'Für Entwickler', en: 'For developers', sv: 'För utvecklare', to: '/', style: 'primary' },
];

export const NOT_LOGGED_IN_BUTTONS = [
  {
    de: 'Einloggen',
    en: 'Log in',
    sv: 'Logga in',
    to: '/login',
    style: 'primary',
  },
  {
    de: 'Anmelden',
    en: 'Sign up',
    sv: 'Skapa konto',
    to: '/signup',
    style: 'secondary',
  },
];

export const LOGGED_IN_BUTTONS = (logout) => [
  {
    de: 'Ausloggen',
    en: 'Log out',
    sv: 'Logga ut',
    func: logout,
    style: 'secondary',
  },
];
